import { NavLink, useLocation, useParams } from 'react-router-dom';
import { NavItem } from '@optiaxiom/react';

import CanUser from '@frontend/components/CanUser';
import { FeatureFlag } from '@frontend/contexts';
import { OperationsName } from '@frontend/types';

type NavigationItemProps = {
  path: string;
  icon: JSX.Element;
  label: string;
  permission: OperationsName;
  featureFlag?: string;
};

/* TODO: Add doc string */
export const NavigationItem = ({
  path,
  icon,
  label,
  permission,
  featureFlag,
}: NavigationItemProps) => {
  const location = useLocation();
  const { instanceId } = useParams();
  const selectedRoute = location.pathname.split('/')[3] || 'chat';

  const navItem = (
    <NavLink
      to={`/instances/${instanceId}/${path}`}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <NavItem active={selectedRoute === path} icon={icon}>
        {label}
      </NavItem>
    </NavLink>
  );

  const withPermission = <CanUser operation={permission}>{navItem}</CanUser>;

  if (featureFlag) {
    return <FeatureFlag featureKey={featureFlag}>{withPermission}</FeatureFlag>;
  }

  return withPermission;
};
